import { Flex, useMantineTheme } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import { HomeSectionTitle } from '~/domains/home/components/sectionComponents';
import HomeSkeletonLayout from '~/domains/home/components/HomeSkeleton';
import { useIsFeatureEnabled } from '~/hooks/useIsFeatureEnabled';
import { FEATURE } from '~/common/enums/feature.enum';
import { Scroller } from '~/domains/design-system/components/Scroller/Scroller';

import { ConnectedPopularChannel } from './ConnectedPopularChannel';
import { usePopularChannels } from './usePopularChannels';

export function HomePopularChannels({ order }: { order?: number }) {
  const theme = useMantineTheme();
  const { t } = useTranslation('channel');

  const isEnabled = useIsFeatureEnabled(FEATURE.ENABLE_POPULAR_CHANNELS_ON_HOME);

  const { isLoading, isError, data } = usePopularChannels({ enabled: isEnabled });

  if (isLoading) {
    return (
      <HomeSkeletonLayout isLoading order={order} />
    );
  }

  if (isError || !data || !isEnabled) {
    return null;
  }

  return (
    <Flex direction="column" style={{ order }}>
      <Flex justify="space-between" w="100%" align="baseline">
        <Flex align="baseline" gap={theme.other.spacing._8}>
          <HomeSectionTitle>{t('popularChannel.title')}</HomeSectionTitle>
        </Flex>
      </Flex>
      <Scroller backgroundColor={theme.colors.gray2[0]}>
        {data?.data?.map((channel) => (
          <ConnectedPopularChannel key={channel.id} channel={channel} />
        ))}
      </Scroller>
    </Flex>
  );
}
